const visibilityMap = {
	// document property: event name
	hidden: 'visibilitychange',
	mozHidden: 'mozvisibilitychange',
	msHidden: 'msvisibilitychange',
	webkitHidden: 'webkitvisibilitychange',
} as const;

const supportedHiddenKey = Object.keys(visibilityMap).find(
	// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Document'.
	(key) => typeof document !== 'undefined' && typeof document[key] !== 'undefined',
);

// @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
export const supportedVisiblityEvent = visibilityMap[supportedHiddenKey];

// @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
export const isPageVisible = () => typeof document !== 'undefined' && !document[supportedHiddenKey];
